import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';
import { Locale } from '../../i18n.config';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  const dollar = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return dollar.format(price);
}

export function titleToPath(title: string): string {
  const path = title.replaceAll(' ', '-').replaceAll("'", '').toLowerCase();

  return path;
}

export function capitalizeFirstLetter(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export interface Translation {
  title: string;
  titleSeo?: string | null;
  descriptionSeo?: string | null;
  shortDescription?: string | null;
  description?: string | null;
  locale: string;
  slug?: string | null;
}

export function getTranslation(translations: Translation[], language: Locale): Translation {
  let translation = translations.filter(t => t?.locale && t.locale === language)[0]
  translation = !translation ? translations.filter(t => t?.locale && t.locale === 'en')[0] : translation;

  return translation;
}
